import { inject, provideAppInitializer, EnvironmentProviders } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SessionService } from '../services/session.service';

const initializationAppFactory = (sessionService: SessionService, translate: TranslateService): Function => {
	return async () => {
		await sessionService.initialize();
		await lastValueFrom(translate.use(sessionService.language));
        await sessionService.initializeModals();
		document.title = translate.instant('PAGE_TITLE');
	}
};

export const APP_INITIALIZE_PROVIDER: EnvironmentProviders = provideAppInitializer(() => {
	return (initializationAppFactory)(inject(SessionService), inject(TranslateService))();
});

